import { NO_DATA } from '../../../Base.constants';

export const Trend = [
  'Strong Deterioration',
  'Moderate Deterioration',
  'Stable',
  'Moderate Improvement',
  'Strong Improvement',
];

export enum Period {
  VERY_LOW = 'VERY_LOW',
  LOW = 'LOW',
  MODERATE = 'MODERATE',
  HIGH = 'HIGH',
  VERY_HIGH = 'VERY_HIGH',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export const NOT_AVAILABLE = 'Not available';
export const NOT_AVAILABLE_SHORT = 'N/A';

export const getPeriod = (value: number): Period => {
  switch (true) {
    case value <= 20:
      return Period.VERY_LOW;
    case value > 20 && value <= 40:
      return Period.LOW;
    case value > 40 && value <= 60:
      return Period.MODERATE;
    case value > 60 && value <= 80:
      return Period.HIGH;
    case value > 80:
      return Period.VERY_HIGH;
    default:
      return Period.NOT_AVAILABLE;
  }
};

export const formatPeriod = (value: number | null): Period => {
  return value !== null ? getPeriod(value) : Period.NOT_AVAILABLE;
};

export const formatStepValue = (step: string | null, possibleValues: string[], canAccess: boolean): string => {
  if (!canAccess) {
    return '';
  }
  return step && possibleValues.includes(step) ? step : NOT_AVAILABLE;
};

export const formatCreCircleBarLabel = (value: number | null, canAccess: boolean): string => {
  if (!canAccess) {
    return NO_DATA;
  }
  return value !== null ? `${value}%` : NOT_AVAILABLE_SHORT;
};

export const formatCqsCircleBarLabel = (value: number | null, canAccess: boolean): string => {
  if (!canAccess) {
    return NO_DATA;
  }
  return value !== null ? value.toString() : NOT_AVAILABLE_SHORT;
};
